<template>
	<div>
		<div slot="header">
			{{ $t('User Data') }}
			<label class="switch switch-sm switch-text switch-info float-right mb-0">
				<input type="checkbox" v-model.lazy="data.resp_user_data_status" class="switch-input" />
				<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
				<span class="switch-handle"></span>
			</label>
		</div>
		<div v-if="data.resp_user_data_status">
			<div class="control" v-show="data.resp_user_data_pars && data.resp_user_data_pars.length">
				<b-card>
					<h4>{{ $t('User Data Processes') }}</h4>
					<div class="row">
						<div class="col-sm-12">
							<table class="table table-bordered table-striped table-sm">
								<thead>
									<tr>
										<th>{{ $t('Name') }}</th>
										<th>{{ $t('Value') }}</th>
										<th>{{ $t('Default Value') }}</th>
										<th>{{ $t('Is Primary') }}</th>
										<th>{{ $t('Edit') }}</th>
										<th>{{ $t('Delete') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(par, index) in data.resp_user_data_pars">
										<td>{{ par.name }}</td>
										<!-- <td> {{ par.var_id }} </td> -->
										<td>{{ par.var_name }}</td>
										<td>{{ par.var_default_value }}</td>
										<td>{{ par.is_primary ? $t('primary') : '' }}</td>
										<td @click="edit_par_mode('resp_user_data_pars', index)">
											<i class="fa fa-edit fa-lg"></i>
										</td>
										<td @click="remove_par('resp_user_data_pars', index)">
											<i class="fa fa-remove fa-lg"></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</b-card>
			</div>
			<div class="control">
				<div class="form-group row">
					<div class="col-sm-6">
						<tooltip label="Set Mode Type" placement="right">
							<select
								name="resp_user_data_mode_name"
								v-model="data.resp_user_data_mode_name"
								v-validate="data.resp_user_data_status ? 'required' : ''"
								:class="{
											'form-control': true,
											'is-invalid': errors.has('resp_user_data_mode_name'),
										}"
							>
								<option value disabled>{{ $t('Choose One') }}</option>
								<option value="insert">{{ $t('Insert') }}</option>
								<option value="update">{{ $t('Update') }}</option>
								<option value="delete">{{ $t('Delete') }}</option>
								<option value="finish">{{ $t('End') }}</option>
							</select>
							<span
								v-if="errors.has('resp_user_data_mode_name')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('resp_user_data_mode_name')) }}</span>
						</tooltip>
					</div>
					<div class="col-sm-6">
						<tooltip label="From Dataset" placement="right">
							<select
								:disabled="!datasets_list.length"
								@change="generate_ds_schema(data.resp_user_data_dataset_id)"
								v-model="data.resp_user_data_dataset_id"
								class="form-control"
							>
								<option value="0" disabled>{{ $t('Choose One') }}</option>
								<option v-for="ds in datasets_list" :value="ds.ds_id">{{ ds.ds_name }}</option>
							</select>
						</tooltip>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-sm-3">
						<tooltip label="Columns Name" placement="right">
							<select
								:disabled="!data.resp_user_data_dataset_id"
								class="form-control"
								v-model="api_par_resp_user_data_pars.name"
							>
								<option value disabled>{{ $t('Choose One') }}</option>
								<option v-for="(v, _i) in user_data_ds_schema" :value="v.name">{{ v.name }}</option>
							</select>
						</tooltip>
					</div>
					<div class="col-sm-3">
						<tooltip label="Variables List" placement="right">
							<select class="form-control" v-model="api_par_resp_user_data_pars.var_id">
								<option value="0" disabled>{{ $t('Choose One') }}</option>
								<option v-for="(v, _i) in vars" :value="v.var_id">{{ v.var_name }}</option>
								<option
									v-if="'ds_schema' in dataset.ds_data"
									v-for="sc in dataset.ds_data.ds_schema"
									:value="sc.name"
								>{{ sc.name }}</option>
								<option
									class="hl-opt"
									v-for="(sk, x) in Object.keys($store.state.sender_info)"
									:value="sk"
								>{{ $t($store.state.sender_info[sk]) }}</option>
							</select>
						</tooltip>
					</div>
					<div class="col-sm-3">
						<tooltip label="Default Value" placement="right">
							<input
								type="text"
								class="form-control"
								v-model="api_par_resp_user_data_pars.var_default_value"
								v-autocomplete="autocomplete"
							/>
						</tooltip>
					</div>
					<div class="col-sm-3">
						<tooltip label="Is Primary" placement="right">
							<br />
							<label class="switch switch-sm switch-text switch-info float-left mb-0">
								<input
									type="checkbox"
									v-model.lazy="api_par_resp_user_data_pars.is_primary"
									class="switch-input"
								/>
								<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
								<span class="switch-handle"></span>
							</label>
						</tooltip>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-sm-4">
						<button
							type="button"
							v-show="par_mode_resp_user_data_pars == 'add'"
							@click="add_par('resp_user_data_pars')"
							class="btn btn-primary btn-sm"
						>{{ $t('Add') }}</button>
						<button
							type="button"
							v-show="par_mode_resp_user_data_pars == 'edit'"
							@click="edit_par('resp_user_data_pars')"
							class="btn btn-primary btn-sm"
						>{{ $t('Edit') }}</button>
					</div>
				</div>
			</div>

			<button class="btn btn-primary" @click="updateResponseData">
				Save
			</button>
		</div>
	
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		data() {
			return {
				datasets_list: [],
				api_par_resp_user_data_pars: {
					is_primary: false,
					var_id: 0,
					var_name: '',
					name: '',
					var_default_value: '',
				},
				user_data_ds_schema: [],
				vars: [],
				dataset: {
					ds_id: 0,
					ds_data: {},
					query_type: 'builder',
					groups: [[]],
					query_syntax: [],
					resp: {
						limit: 1,
						via: 'text',
						title: '',
						subtitle: '',
						media: '',
						item_label: '',
						item_value: '',
						buttons: [
							{
								item_label_key: '',
								item_value_key: '',
							},
						],
						receipt: {
							name: '',
							merchant: '',
							order_number: 0,
							timestamp: 0,
							order_url: 0,
							currency: 'EGP',
							payment_method: '',
							dataset_id: 0,
							elem_title_col: '',
							elem_price_col: 0,
							elem_amount_col: 1,
							elem_image_col: '',
							address: '',
							sub_total: 0,
							shipping_cost: 0,
							total_tax: 0,
							total_cost: 0,
						},
					},
				},
				autocomplete: {},
				par_mode_resp_user_data_pars: 'add',
				data: {
					resp_user_data_dataset_id: 0,
					resp_user_data_pars: [],
					resp_user_data_mode_name: '',
					resp_user_data_status: 0,
				},
				datasets_schema: {},
			}
		},
		methods: {
			get_datasets() {
				return new Promise((resolve, reject) => {
					axios
						.get('/dataset/get_list?type=dataset,menu', {})
						.then((res) => {
							if (res.data.status == 1) {
								this.datasets_list = res.data.private
								for (var _i in res.data.private) {
									this.datasets_schema[res.data.private[_i].ds_id] = {}
									for (var _s in res.data.private[_i].ds_schema) {
										this.datasets_schema[res.data.private[_i].ds_id][
											res.data.private[_i].ds_schema[_s]['name']
										] = res.data.private[_i].ds_schema[_s]['type']
									}
								}
							}
							resolve(res)
						})
						.catch((e) => reject(e))
				})
			},
			add_par(key) {
				var par_name = 'api_par_' + key
				
				if (
					this[par_name].name != '' &&
					(this[par_name].var_id != '' || this[par_name].var_default_value != '') &&
					!this.check_exist_par(key, this[par_name].name)
				) {
					// set var name where var_id belongs to sender info object
					if (this.$store.state.sender_info.hasOwnProperty(this[par_name].var_id)) {
						this[par_name].var_name = this.$store.state.sender_info[this[par_name].var_id]
					} else {
						// set default var
						for (var _i in this.vars) {
							if (this.vars[_i].var_id == this[par_name].var_id) {
								this[par_name].var_name = this.vars[_i].var_name
								break
							}
						}
					}

					// find col type
					for (var _d in this.user_data_ds_schema) {
						if (this.user_data_ds_schema[_d]['name'] == this[par_name]['name']) {
							this[par_name]['type'] = this.user_data_ds_schema[_d]['type']
						}
					}

					this.data[key].push(this[par_name])

					this[par_name] = {
						var_name: '',
						var_id: 0,
						name: '',
						var_default_value: '',
					}
				}
			},

			edit_par(key) {
				var par_name = 'api_par_' + key

				if (this['active_par_index_' + key] >= 0 && this[par_name].name != '') {
					if (this.$store.state.sender_info.hasOwnProperty(this[par_name].var_id)) {
						this[par_name].var_name = this.$store.state.sender_info[this[par_name].var_id]
					} else {
						for (var _i in this.vars) {
							if (this.vars[_i].var_id == this[par_name].var_id) {
								this[par_name].var_name = this.vars[_i].var_name
								break
							}
						}
					}

					for (var i = 0; i < this.data[key].length; i++) {
						if (i == this['active_par_index_' + key]) {
							this.data[key][i] = this[par_name]
						}
					}
					this['active_par_index_' + key] = -1
					this['par_mode_' + key] = 'add'
					this[par_name] = {
						var_name: '',
						var_id: 0,
						name: '',
						var_default_value: '',
					}
				}
			},

			edit_par_mode(key, index) {
				this['par_mode_' + key] = 'edit'
				this['active_par_index_' + key] = index
				this['api_par_' + key] = this.data[key][index]
			},

			check_exist_par(key, name) {
				for (var i = 0; i < this.data[key].length; i++) {
					if (this.data[key][i].name == name) {
						return true
					}
				}
				return false
			},

			remove_par(key, index) {
				if (this.data[key] && this.data[key][index]) {
					this.data[key].splice(index, 1)
				}
			},

			get_command_vars() {
				return new Promise((resolve, reject) => {
					axios
						.post('/command_var/get_all/' + this.command_id, {}, {})
						.then((res) => {
							if (res.data.status == 1) {
								this.vars = res.data.data
								// map id to names
								for (var _var in res.data.data) {
									this.vars_ids[res.data.data[_var].var_id] = res.data.data[_var].var_name
								}
								// Set Sender Info options
								this.vars_ids_with_sender_vars = {
									...this.vars_ids,
									...this.$store.state.sender_info,
								}
								this.setAutoCompeleteSchema()
							}
							resolve('success')
						})
						.catch((e) => resolve('error'))
				})
			},
			generate_ds_schema(ds_id) {
				this.user_data_ds_schema = []
				for (var i = this.datasets_list.length - 1; i >= 0; i--) {
					if (ds_id == this.datasets_list[i].ds_id) {
						this.user_data_ds_schema = this.datasets_list[i].ds_schema
						break
					}
				}
			},
			updateResponseData() {
				this.$store.commit('setResponseDataProperty', this.data)

				this.$router.push(`/services/${this.serviceId}/commands/${this.commandId}/result/fallback`)
			},
		},
		mounted() {
			this.get_datasets();
			this.get_command_vars();

			this.data.resp_user_data_dataset_id = this.$store.state.responseData.resp_user_data_dataset_id
			this.data.resp_user_data_pars = this.$store.state.responseData.resp_user_data_pars
			this.data.resp_user_data_mode_name = this.$store.state.responseData.resp_user_data_mode_name
			this.data.resp_user_data_status = this.$store.state.responseData.resp_user_data_status
		},
		computed: {
			serviceId() {
				return this.$route.params.service_id
			},
			commandId() {
				return this.$route.params.command_id
			},
		},
	}
</script>
